/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Features_Item_4_DescInputs */

const es_home_features_item_4_desc = /** @type {(inputs: Home_Features_Item_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada resultado incluye metadatos, fechas, participantes y enlaces directos.`)
};

const en_home_features_item_4_desc = /** @type {(inputs: Home_Features_Item_4_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every result includes metadata, dates, participants, and direct links.`)
};

/**
* | output |
* | --- |
* | "Every result includes metadata, dates, participants, and direct links." |
*
* @param {Home_Features_Item_4_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_features_item_4_desc = /** @type {((inputs?: Home_Features_Item_4_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Features_Item_4_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_features_item_4_desc(inputs)
	return en_home_features_item_4_desc(inputs)
});
export { home_features_item_4_desc as "home.features.item_4_desc" }